export default __webpack_public_path__ + "static/media/eye-closed.07bbda5a.png";